import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
class BoatOwnerList extends React.Component {
  state = {
    users_data: [
      {
        name: 'abc Owner',
        open: '10 AM',
        close: '10 PM',
      },
    ],
    Owner_list: [],
  }
  componentDidMount() {
    this.dashbord()
  }
  dashbord = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/admin/list-users/admin', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Owner_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id, isActive) => {
    var data = {
      userId: id,
      is_active: isActive,
    }
    await axios
      .post(Constant.getAPI() + '/user/update-user', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.dashbord()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    const columns = [
      {
        name: 'user_profile',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (user_profile) => {
            return (
              <div>
                {user_profile !== null ? (
                  <div>
                    {user_profile?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            user_profile !== undefined && user_profile !== null && user_profile !== {}
                              ? Constant.getImage() + user_profile
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          user_profile !== undefined && user_profile !== null && user_profile !== {}
                            ? Constant.getImage() + user_profile
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      user_profile !== undefined && user_profile !== null && user_profile !== {}
                        ? Constant.getImage() + user_profile
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },

      {
        name: 'first_name',
        label: 'Owner Name',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'email',
        label: 'email',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'phone',
        label: 'Phone',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'country_code',
        label: 'Country Code',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'id',
        label: 'Captain List',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <Link
                to={`/boat-Owner/alloted-captain/` + id}
                className="m-r-15 text-muted"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-original-title="View captain list "
              >
                view
              </Link>
            )
          },
        },
      },

      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[7]}
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[7], !is_active)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={'/boat-Owner/add/' + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                {/* <Link
                 // to={"/Owner/branch/" + OwnerID}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-building-alt text-purple"></i>
                </Link> */}
                {/* <Link to={"/delivery-charges/" + id}
              className="m-r-15 text-muted"
              data-toggle="tooltip"
              data-placement="top" title=""
              data-original-title="Add Delivery Charges">
              <i className="f-20 icofont icofont-shopping-cart text-primary"></i>
            </Link> */}
                {/* <Link
              to={"/shop/products/" + OwnerID}
              className="m-r-15 text-muted"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-original-title="View Owner Products ">
              <i className="f-22 icofont icofont-eye text-dark"></i>
            </Link> */}
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Owner Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Owner List</h4>
                    </div>
                  </div>
                  <Link
                    to="/boat-Owner/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Owner
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Owner List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Owner List'}
                          className="table-responsive"
                          data={this.state.Owner_list}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BoatOwnerList
